module.exports = __webpack_public_path__ + "img/profits.44754cc0.png";